var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import SearchContentBlock from "./Generic/SearchContentBlock";
import StockName from "./SearchStockChunks/StockName";
import di from "@mainDi/features/Search/servicelocator";
import { useNavigate } from "react-router-dom";
import ErrorNotification from "@frameworks/web/components/generic/error";
import { ErrorDisplayType } from "@frameworks//web/components/generic/error";
import { SearchAssetTypeEnum } from "./constant";
import { getSearchEnum } from "./SearchTabs";
var OptionChainToolBlock = function (props) {
    var navigate = useNavigate();
    var _a = __read(useState(), 2), optionChainList = _a[0], setOptionChainList = _a[1];
    var _b = __read(useState({ isOpen: false, error: undefined }), 2), error = _b[0], setError = _b[1];
    useEffect(function () {
        var _a;
        setError({ isOpen: false, error: undefined });
        if (((_a = props === null || props === void 0 ? void 0 : props.searchKey) === null || _a === void 0 ? void 0 : _a.length) > 2) {
            di.search
                .getOptionChainToolData({
                searchText: props.searchKey,
                assetsFlag: props.assetFlag.toString(),
                assetTypes: props.activeTab === SearchAssetTypeEnum.ComOpt
                    ? "COMOPT"
                    : props.activeTab === SearchAssetTypeEnum.CurOpt
                        ? "CUROPT"
                        : "Option",
            })
                .then(function (data) {
                var _a;
                setOptionChainList(data.optionChain);
                if (data.optionChain.length <= 1) {
                    props.setOptions(false);
                    props.setSelectedOptions(data === null || data === void 0 ? void 0 : data.optionChain[0]);
                }
                if (data.generalResponse) {
                    var result = (_a = data === null || data === void 0 ? void 0 : data.generalResponse) === null || _a === void 0 ? void 0 : _a.assetTypeGroup;
                    var active = result.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === getSearchEnum(props === null || props === void 0 ? void 0 : props.activeTab); })[0];
                    if (result.indexOf(active) !== -1)
                        result.splice(result.indexOf(active), 1);
                    if (!!active)
                        result.unshift(active);
                    else
                        result.unshift({
                            assetType: getSearchEnum(props === null || props === void 0 ? void 0 : props.activeTab),
                            data: [],
                        });
                    props === null || props === void 0 ? void 0 : props.setSearchList(result);
                }
            })
                .catch(function (err) {
                setOptionChainList(undefined);
                setError({ isOpen: true, error: err });
            });
        }
        else {
            props.setSelectedOptions(undefined);
            props.setActiveTab("All");
            props.setOptions(false);
            setOptionChainList(undefined);
        }
    }, [props.searchKey]);
    return (
    // <div
    //   className={`option-search-block  pdt-20 ${
    //     device?.isDesktop ? "" : "pdlr-15"
    //   }`}
    // >
    //   <div className="searchdata-border-block">
    React.createElement(React.Fragment, null, (error === null || error === void 0 ? void 0 : error.isOpen) ? (React.createElement(ErrorNotification, { isOpen: error === null || error === void 0 ? void 0 : error.isOpen, error: error === null || error === void 0 ? void 0 : error.error, displayType: ErrorDisplayType.INSECTION })) : ((optionChainList === null || optionChainList === void 0 ? void 0 : optionChainList.length) > 0 &&
        (optionChainList === null || optionChainList === void 0 ? void 0 : optionChainList.map(function (x) {
            return (React.createElement("div", { className: "search-block-common" },
                React.createElement(SearchContentBlock, { topleft: React.createElement(StockName, { stockName: x.underlyingSymbolName }), topright: props.activeTab !== SearchAssetTypeEnum.ComOpt && (React.createElement("div", { onClick: function () {
                            navigate("/option-chain-tool/".concat(x.underlyingSymbolName, "/").concat(x.idx, "/").concat(x.exchange));
                            props.setSearchPopup(false);
                        }, className: "txt-underline" }, "Option Chain")), onSelected: function () {
                        // props.setSearch(x.underlyingSymbolName);
                        props.setOptions(false);
                        props.setSelectedOptions(x);
                    } })));
        }))))
    //   </div>
    // </div>
    );
};
export default OptionChainToolBlock;
